/*
 * CV2 in-page search overlay.
 *
 * Any [data-cv2-search-open] element opens it. Those are real links to the
 * search page, so this only takes over when JS is available.
 *
 * Results come from Shopify's predictive search endpoint. Submitting the form
 * falls through to the normal search results page.
 */
(function () {
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 220;

  function init() {
    var root = document.querySelector('[data-cv2-search]');
    if (!root || root.dataset.cv2Bound) return;
    root.dataset.cv2Bound = '1';

    var input = root.querySelector('[data-cv2-search-input]');
    var results = root.querySelector('[data-cv2-search-results]');
    var form = root.querySelector('[data-cv2-search-form]');
    if (!input || !results || !form) return;

    var lastFocus = null;
    var timer = null;
    var controller = null;

    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      input.focus();
    }

    function close() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () { root.hidden = true; }, 220);
      if (lastFocus) lastFocus.focus();
    }

    function money(cents) {
      // Shopify returns a preformatted price string on the predictive endpoint;
      // this is only a fallback for the raw-cents shape.
      if (typeof cents !== 'number') return cents || '';
      return (cents / 100).toFixed(2);
    }

    function render(products, query) {
      if (!products.length) {
        results.innerHTML =
          '<p class="cv2-search__empty">No matches for &ldquo;' +
          escapeHtml(query) + '&rdquo;</p>';
        return;
      }
      var html = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url + '&width=120" alt="" width="56" height="56" loading="lazy">'
          : '<span class="cv2-search__thumb-blank"></span>';
        var price = p.price != null ? money(p.price) : '';
        return '<a class="cv2-search__hit" href="' + p.url + '">' +
                 '<span class="cv2-search__thumb">' + img + '</span>' +
                 '<span class="cv2-search__hit-text">' +
                   '<span class="cv2-search__hit-title">' + escapeHtml(p.title) + '</span>' +
                   (price ? '<span class="cv2-search__hit-price">' + price + '</span>' : '') +
                 '</span>' +
               '</a>';
      }).join('');
      html += '<a class="cv2-search__all" href="' + form.action + '?q=' +
              encodeURIComponent(query) + '&type=product">See all results</a>';
      results.innerHTML = html;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function search(query) {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
                '&resources[type]=product&resources[limit]=6' +
                '&resources[options][unavailable_products]=last';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results &&
                          data.resources.results.products) || [];
          render(products, query);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          results.innerHTML = '<p class="cv2-search__empty">Search is unavailable right now.</p>';
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (timer) clearTimeout(timer);
      if (q.length < MIN_CHARS) { results.innerHTML = ''; return; }
      results.classList.add('is-loading');
      timer = setTimeout(function () {
        results.classList.remove('is-loading');
        search(q);
      }, DEBOUNCE_MS);
    });

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cv2-search-open]');
      if (opener) { open(e); return; }
      if (e.target.closest('[data-cv2-search-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
